// extracted by mini-css-extract-plugin
export var component = "CalendarBadge-module--component--FfinG";
export var day = "CalendarBadge-module--day--2g795";
export var month = "CalendarBadge-module--month--4B098";